<template>
  <div class="page-wrapper">
    <div :class="['header-wrap style7', { sticky: isSticky }]">
      <MainNavbar />
    </div>
    <MainBanner />
    <AboutUs />
    <BestServices />
    <OurDepartment />
    <BookAnAppointment />
    <OurPricing />
    <GalleryExhibition />
    <PeopleAlsoAsk />
    <OurDoctors />
    <OurTestimonials />
    <TouchWithUs />
    <LatestNews />
    <MainFooter />
  </div>
</template>

<script lang="ts">
import MainNavbar from "../Layouts/MainNavbar.vue";
import MainBanner from "../HomeSeven/MainBanner.vue";
import AboutUs from "../HomeSeven/AboutUs.vue";
import BestServices from "../HomeSeven/BestServices.vue";
import OurDepartment from "../HomeSeven/OurDepartment.vue";
import BookAnAppointment from "../HomeSeven/BookAnAppointment.vue";
import OurPricing from "../HomeSeven/OurPricing.vue";
import GalleryExhibition from "../HomeSeven/GalleryExhibition.vue";
import PeopleAlsoAsk from "../HomeSeven/PeopleAlsoAsk.vue";
import OurDoctors from "../HomeSeven/OurDoctors.vue";
import OurTestimonials from "../HomeSeven/OurTestimonials.vue";
import TouchWithUs from "../HomeSeven/TouchWithUs.vue";
import LatestNews from "../HomeSeven/LatestNews.vue";
import MainFooter from "../Layouts/MainFooter.vue";

import { defineComponent } from "vue";

export default defineComponent({
  name: "HomeSevenPage",
  components: {
    MainNavbar,
    MainBanner,
    AboutUs,
    BestServices,
    OurDepartment,
    BookAnAppointment,
    OurPricing,
    GalleryExhibition,
    PeopleAlsoAsk,
    OurDoctors,
    OurTestimonials,
    TouchWithUs,
    LatestNews,
    MainFooter,
  },
  data() {
    return {
      isSticky: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", () => {
      const scrollPos = window.scrollY;
      this.isSticky = scrollPos >= 100;
    });
  },
});
</script>